import { render, staticRenderFns } from "./ProductFilter.component.pug?vue&type=template&id=18ef939f&scoped=true&lang=pug&"
import script from "./ProductFilter.component.ts?vue&type=script&lang=ts&"
export * from "./ProductFilter.component.ts?vue&type=script&lang=ts&"
import style0 from "./ProductFilter.component.scss?vue&type=style&index=0&id=18ef939f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18ef939f",
  null
  
)

export default component.exports